import { HTTP_CP_GetInbox_Response, HTTP_CP_GetInbox_Response_InboxMessage } from '@api-new/reportingservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';
import { InboxFilterModel } from '@shared/store/inbox/models/inbox-filter.model';

export const getInbox = createAction('[INBOX] Get Inbox');
export const getInboxSuccess = createAction('[INBOX] Get Inbox Success', props<{ response: HTTP_CP_GetInbox_Response }>());
export const getInboxFailure = createAction('[INBOX] Get Inbox Failure', props<{ error: ErrorModel }>());

export const markInboxMessageAsRead = createAction(
  '[INBOX] Mark Inbox Message As Read',
  props<{ message: HTTP_CP_GetInbox_Response_InboxMessage }>(),
);
export const markInboxMessageAsReadSuccess = createAction(
  '[INBOX] Mark Inbox Message As Read Success',
  props<{ message: HTTP_CP_GetInbox_Response_InboxMessage }>(),
);
export const markInboxMessageAsReadFailure = createAction('[INBOX] Mark Inbox Message As Read Failure', props<{ error: ErrorModel }>());

export const markAllInboxMessagesAsRead = createAction('[INBOX] Mark All Inbox Messages As Read');
export const markAllInboxMessagesAsReadSuccess = createAction('[INBOX] Mark All Inbox Messages As Read Success');
export const markAllInboxMessagesAsReadFailure = createAction(
  '[INBOX] Mark All Inbox Messages As Read Failure',
  props<{ error: ErrorModel }>(),
);

export const setInboxFilter = createAction('[INBOX] Set Inbox Filter', props<{ filter: InboxFilterModel }>());
